/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurveyListItemDto
 */
export interface SurveyListItemDto {
    /**
     * Survey unique identifier
     * @type {string}
     * @memberof SurveyListItemDto
     */
    id: string;
    /**
     * Survey name
     * @type {string}
     * @memberof SurveyListItemDto
     */
    name: string;
    /**
     * Survey stable code (e.g. COPRO_MRI)
     * @type {string}
     * @memberof SurveyListItemDto
     */
    code?: string | null;
    /**
     * Survey version number
     * @type {number}
     * @memberof SurveyListItemDto
     */
    version: number;
    /**
     * Whether the survey is active
     * @type {boolean}
     * @memberof SurveyListItemDto
     */
    isActive: boolean;
    /**
     * Associated branch ID
     * @type {string}
     * @memberof SurveyListItemDto
     */
    branchId?: string | null;
    /**
     * Associated branch name
     * @type {string}
     * @memberof SurveyListItemDto
     */
    branchName?: string | null;
    /**
     * Context ID
     * @type {string}
     * @memberof SurveyListItemDto
     */
    contextId: string;
    /**
     * Context label
     * @type {string}
     * @memberof SurveyListItemDto
     */
    contextLabel: string;
    /**
     * Creation timestamp
     * @type {Date}
     * @memberof SurveyListItemDto
     */
    creationTime: Date;
    /**
     * Last modification timestamp
     * @type {Date}
     * @memberof SurveyListItemDto
     */
    lastModificationTime?: Date | null;
    /**
     * Number of questions in the survey
     * @type {number}
     * @memberof SurveyListItemDto
     */
    questionCount: number;
}

/**
 * Check if a given object implements the SurveyListItemDto interface.
 */
export function instanceOfSurveyListItemDto(value: object): value is SurveyListItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('contextId' in value) || value['contextId'] === undefined) return false;
    if (!('contextLabel' in value) || value['contextLabel'] === undefined) return false;
    if (!('creationTime' in value) || value['creationTime'] === undefined) return false;
    if (!('questionCount' in value) || value['questionCount'] === undefined) return false;
    return true;
}

export function SurveyListItemDtoFromJSON(json: any): SurveyListItemDto {
    return SurveyListItemDtoFromJSONTyped(json, false);
}

export function SurveyListItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveyListItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'version': json['version'],
        'isActive': json['isActive'],
        'branchId': json['branchId'] == null ? undefined : json['branchId'],
        'branchName': json['branchName'] == null ? undefined : json['branchName'],
        'contextId': json['contextId'],
        'contextLabel': json['contextLabel'],
        'creationTime': (new Date(json['creationTime'])),
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : (new Date(json['lastModificationTime'])),
        'questionCount': json['questionCount'],
    };
}

export function SurveyListItemDtoToJSON(json: any): SurveyListItemDto {
    return SurveyListItemDtoToJSONTyped(json, false);
}

export function SurveyListItemDtoToJSONTyped(value?: SurveyListItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'code': value['code'],
        'version': value['version'],
        'isActive': value['isActive'],
        'branchId': value['branchId'],
        'branchName': value['branchName'],
        'contextId': value['contextId'],
        'contextLabel': value['contextLabel'],
        'creationTime': ((value['creationTime']).toISOString()),
        'lastModificationTime': value['lastModificationTime'] == null ? undefined : ((value['lastModificationTime'] as any).toISOString()),
        'questionCount': value['questionCount'],
    };
}

